import { render, staticRenderFns } from "./bookIntro.vue?vue&type=template&id=5cdb2008&scoped=true&"
import script from "./bookIntro.vue?vue&type=script&lang=js&"
export * from "./bookIntro.vue?vue&type=script&lang=js&"
import style0 from "./bookIntro.vue?vue&type=style&index=0&id=5cdb2008&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb2008",
  null
  
)

export default component.exports